<template>
  <v-row justify="center">
    <v-dialog v-model="isOpen" scrollable persistent width="750px">
      <v-form
        class="single-form"
        ref="form"
        v-model="valid"
        v-on:submit.prevent="validate"
      >
        <v-card>
          <v-toolbar flat dark color="rgb(51, 97, 137)">
            <v-toolbar-title>
              <v-icon left>mdi-check-box-outline</v-icon
              >{{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.insertExam.insertSingle.addSingle'
                )
              }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  dark
                  :disabled="loading"
                  @click="closeDialogQuestion"
                  v-on="on"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </template>
              <span class="subtitle-1">{{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.insertExam.close'
                )
              }}</span>
            </v-tooltip>
          </v-toolbar>

          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-alert text type="info" border="left">
                  <strong class="font-weight-bold">
                    {{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.lectureStep.insertExam.msg20'
                      )
                    }}
                    <label class="headExplan">"</label
                    >{{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.lectureStep.insertExam.msg21'
                      )
                    }}
                    <label class="headExplan">"</label>
                  </strong>
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.lectureStep.insertExam.msg22'
                    )
                  }}
                  <label class="font-weight-bold">{{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.lectureStep.insertExam.msg23'
                    )
                  }}</label>
                </v-alert>
              </v-col>
            </v-row>
            <v-row v-if="randomSetting == true">
              <v-col cols="8">
                <p class="title">
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.lectureStep.insertExam.insertSingle.chooseQuestionGroup'
                    )
                  }}<span class="red--text">*</span>
                </p>
                <v-autocomplete
                  v-model="selectTagLevel"
                  :items="arrTagLevel"
                  item-text="text"
                  class="mb-2 body-1"
                  item-value="id"
                  @change="changeTag(selectTagLevel)"
                  outlined
                  :placeholder="
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.lectureStep.insertExam.insertSingle.chooseQuestionGroup'
                    )
                  "
                  background-color="white"
                ></v-autocomplete>
              </v-col>
              <v-col cols="4"
                ><p class="title">
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.lectureStep.insertExam.insertSingle.score'
                    )
                  }}
                </p>
                <v-text-field
                  disabled
                  outlined
                  v-model.number="scoreTag"
                  type="number"
                ></v-text-field
              ></v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <p class="title">
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.lectureStep.insertExam.insertSingle.question'
                    )
                  }}
                  <span class="red--text">*</span>
                </p>
                <quill-editor
                  class="editor"
                  ref="description"
                  v-model="question"
                  :rules="questionRules"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <div class="d-flex mb-2">
                  <p class="title">
                    {{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.lectureStep.insertExam.insertSingle.addVoiceOpt'
                      )
                    }}
                  </p>
                </div>
                <!-- <div class="upload-btn-wrapper">
                  <button class="btn-choose body-1 font-weight-medium">
                    <v-icon>mdi-upload</v-icon>Upload audio
                  </button>
                  <input
                    type="file"
                    name="myfile"
                    @change="preview"
                    accept="image/png, image/jpeg, image/bmp"
                  />
                </div>-->

                <v-card height="100" outlined v-if="audio_id === null">
                  <div class="text-center center-panel">
                    <v-btn
                      outlined
                      color="blue-grey"
                      @click="openMediaDialog('audio')"
                    >
                      <v-icon left>mdi-volume-high</v-icon
                      >{{
                        $vuetify.lang.t(
                          '$vuetify.courseManagement.lectureStep.insertExam.insertSingle.addVoice'
                        )
                      }}
                    </v-btn>
                  </div>
                </v-card>
                <v-card height="85%" v-if="audio_id" outlined>
                  <v-row>
                    <v-col class="text-right">
                      <v-btn
                        elevation="0"
                        class="mb-0 body-2 error--text text-capitalize"
                        color="white"
                        v-if="audio_id"
                        @click="deletemedia('audio')"
                      >
                        <p class="mb-0">
                          {{
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.lectureStep.insertExam.delete'
                            )
                          }}
                        </p>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="px-5">
                      <vuetify-audio
                        :file="audio_url"
                        :audioPlaying.sync="audioPlaying"
                      ></vuetify-audio>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
              <v-col cols="6">
                <div class="d-flex mb-2">
                  <p class="title">
                    {{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.lectureStep.insertExam.insertSingle.addVdoOpt'
                      )
                    }}
                  </p>
                </div>
                <v-card height="100" outlined v-if="video_id === null">
                  <div class="text-center center-panel">
                    <v-btn
                      outlined
                      color="blue-grey"
                      @click="openMediaDialog('video')"
                    >
                      <v-icon left>mdi-video</v-icon
                      >{{
                        $vuetify.lang.t(
                          '$vuetify.courseManagement.lectureStep.insertExam.insertSingle.addVdo'
                        )
                      }}
                    </v-btn>
                  </div>
                </v-card>
                <v-card height="85%" outlined v-if="video_id">
                  <v-row>
                    <v-col class="text-right">
                      <v-btn
                        elevation="0"
                        class="mb-0 body-2 error--text text-capitalize"
                        color="white"
                        v-if="video_id"
                        @click="deletemedia('video')"
                      >
                        <p class="mb-0">
                          {{
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.lectureStep.insertExam.delete'
                            )
                          }}
                        </p>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="px-5">
                      <div class="videoPlayer ma-auto">
                        <video-player
                          class="video-player-box videoContainer"
                          ref="videoPlayer"
                          :options="playerOptions"
                          :playsinline="true"
                          customEventName="customstatechangedeventname"
                          @ready="playerReadied"
                        ></video-player>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" v-if="randomSetting == false">
                <p class="title">
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.lectureStep.insertExam.insertSingle.score'
                    )
                  }}
                  <span class="red--text">*</span>
                </p>
                <v-text-field
                  type="number"
                  outlined
                  :rules="scoreRules"
                  clearable
                  class="textField"
                  :placeholder="
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.lectureStep.insertExam.insertSingle.score'
                    )
                  "
                  v-model.number="question_score"
                  min="0"
                  @change="checkMinScore"
                ></v-text-field>
              </v-col>
              <!-- <v-col cols="6">
                <p class="title">
                  {{
                    $vuetify.lang.t(
                      "$vuetify.courseManagement.lectureStep.insertExam.insertSingle.randomType"
                    )
                  }}
                  <span class="red--text">*</span>
                </p>
                <v-radio-group v-model="setRandomChoice" mandatory row>
                  <v-radio
                    :label="
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.lectureStep.insertExam.insertSingle.noRandom'
                      )
                    "
                    :value="false"
                  ></v-radio>
                  <v-radio
                    :label="
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.lectureStep.insertExam.insertSingle.random'
                      )
                    "
                    :value="true"
                  ></v-radio>
                </v-radio-group>
              </v-col> -->
            </v-row>
            <p class="title">
              {{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.insertExam.insertSingle.choiceList'
                )
              }}
            </p>
            <p class="subtitle-1" v-if="answer.length == 0">
              {{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.insertExam.insertSingle.choiceMsg3'
                )
              }}
            </p>
            <p class="subtitle-1" v-if="answer.length > 0">
              {{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.insertExam.insertSingle.msg1'
                )
              }}{{ ' '
              }}{{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.insertExam.insertSingle.msg2'
                )
              }}
            </p>
            <v-card elevation="0" class="mt-5" v-if="answer.length > 0">
              <!-- <v-alert text type="info" border="left">
                <strong class="font-weight-bold"
                  >{{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.lectureStep.insertExam.insertSingle.msg1'
                    )
                  }}{{ ' ' }}</strong
                >{{
                  $vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.insertExam.insertSingle.msg2'
                  )
                }}
              </v-alert> -->
              <v-row v-if="answer.length >= 1">
                <v-col cols="2">
                  <p class="subtitle-1 mb-0">
                    {{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.lectureStep.insertExam.insertSingle.answer'
                      )
                    }}
                  </p>
                </v-col>
                <v-col cols="10" class="text-center">
                  <p class="subtitle-1mb-0">
                    {{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.lectureStep.insertExam.insertSingle.choices'
                      )
                    }}
                  </p>
                </v-col>
              </v-row>
              <div v-for="(item, index) in answer" :key="index">
                <v-radio-group v-model="answer_correct" :mandatory="false">
                  <v-row>
                    <v-col cols="1">
                      <v-card-title class="px-0 pt-4">
                        <v-radio :value="index" :key="index"></v-radio>
                      </v-card-title>
                    </v-col>
                    <v-col cols="11" class="ma-0 pa-0">
                      <v-card outlined>
                        <v-card-text class="pb-0">
                          <v-row class="mx-0">
                            <div class="subtitle-1">
                              {{
                                $vuetify.lang.t(
                                  '$vuetify.courseManagement.lectureStep.insertExam.insertSingle.choice'
                                ) +
                                (index + 1) +
                                ' '
                              }}
                            </div>
                            <v-spacer></v-spacer>
                            <v-btn
                              v-if="item.boolean == false"
                              :disabled="bools == true"
                              elevation="0"
                              class="mb-0 body-2 text-primary text-capitalize"
                              color="white"
                              @click="editOptionAnswer(item)"
                            >
                              <p class="mb-0">
                                {{
                                  $vuetify.lang.t(
                                    '$vuetify.courseManagement.courseList.edit'
                                  )
                                }}
                              </p>
                            </v-btn>
                            <v-divider
                              v-if="item.boolean == false"
                              inset
                              vertical
                              class="mb-2 mx-1"
                            ></v-divider>
                            <v-btn
                              v-if="item.boolean == false"
                              elevation="0"
                              class="mb-0 body-2 error--text text-capitalize"
                              color="white"
                              @click="openRemoveItemDialog(item)"
                              :disabled="answer.length <= 1 || bools == true"
                            >
                              <p class="mb-0">
                                {{
                                  $vuetify.lang.t(
                                    '$vuetify.courseManagement.lectureStep.insertExam.delete'
                                  )
                                }}
                              </p>
                            </v-btn>
                            <v-btn
                              v-if="item.boolean == true"
                              elevation="0"
                              class="mb-0 body-2 text-primary text-capitalize"
                              color="white"
                              :disabled="!item.text"
                              @click="confirmOption(item)"
                            >
                              <p class="mb-0">
                                {{
                                  $vuetify.lang.t(
                                    '$vuetify.courseManagement.lectureStep.insertExam.ok'
                                  )
                                }}
                              </p>
                            </v-btn>
                            <v-divider
                              v-if="item.boolean == true"
                              inset
                              vertical
                              class="mb-2 mx-1"
                            ></v-divider>
                            <v-btn
                              v-if="item.boolean == true"
                              elevation="0"
                              class="mb-0 body-2 text-capitalize"
                              color="white"
                              @click="canCelEditOptionAnswer(item)"
                            >
                              <p class="mb-0">
                                {{
                                  $vuetify.lang.t(
                                    '$vuetify.courseManagement.lectureStep.insertExam.cancel'
                                  )
                                }}
                              </p>
                            </v-btn>
                          </v-row>
                        </v-card-text>
                        <v-card-title
                          v-if="item.boolean == false"
                          class="py-0"
                          v-html="item.text"
                        ></v-card-title>
                        <v-card-title
                          class="title mb-0"
                          v-html="tempChoiceAnswer"
                          v-if="item.boolean == true"
                        >
                        </v-card-title>
                        <quill-editor
                          v-if="item.boolean == true"
                          class="editor editor-style pa-3"
                          ref="description"
                          v-model="item.text"
                        />
                      </v-card>
                    </v-col>
                  </v-row>
                  <!-- <v-row>
                    <v-col cols="10">
                      <quill-editor
                        class="editor"
                        v-model="answer[index].text"
                        ref="answer"
                        :value="answer[index].text"
                      />
                    </v-col>
                    <v-col cols="1">
                      <div class="py-1 text-center">
                        <v-tooltip left>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              icon
                              v-on="on"
                              color="error"
                              @click="removeRow(index)"
                              :disabled="answer.length<=1"
                            >
                              <v-icon>mdi-trash-can</v-icon>
                            </v-btn>
                          </template>
                          <span class="subtitle-1">ลบคำตอบ</span>
                        </v-tooltip>
                      </div>
                    </v-col>
                  </v-row>-->
                </v-radio-group>
              </div>
            </v-card>
            <!-- <v-row class="justify-center ma-3">
              <v-btn
                :disabled="bools == true"
                elevation="0"
                class="pl-5 pr-5 mb-0 body-2 text-primary text-capitalize"
                color="white"
                @click="addRowAnswer"
              >
                <v-icon left>mdi-plus</v-icon>
                {{
                  $vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.insertExam.insertSingle.addChoice'
                  )
                }}
              </v-btn>
            </v-row> -->
            <v-row>
              <v-card class="pa-5" elevation="0" color="grey lighten-5">
                <p class="title">
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.lectureStep.insertExam.insertSingle.choice'
                    )
                  }}<span class="red--text"> *</span>
                </p>
                <p class="subtitle-1">
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.lectureStep.insertExam.insertSingle.choiceMsg1'
                    )
                  }}
                </p>

                <quill-editor
                  class="editor"
                  v-model="addAnswer"
                  ref="answers"
                  :value="addAnswer"
                />
                <v-row>
                  <v-col class="text-right">
                    <v-btn
                      :disabled="addAnswer == ''"
                      elevation="0"
                      class="px-10 ma-2 subtitle-2 text-capitalize font-weight-light button-primary"
                      @click="addRowAnswer()"
                      >{{
                        $vuetify.lang.t(
                          '$vuetify.courseManagement.lectureStep.insertExam.insertSingle.addChoice'
                        )
                      }}</v-btn
                    >
                  </v-col>
                </v-row>
              </v-card>
            </v-row>
            <v-row>
              <v-card class="pa-5" elevation="0" color="grey lighten-5">
                <p class="title">
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.lectureStep.insertExam.insertSingle.answerDescription'
                    )
                  }}
                </p>
                <p class="subtitle-1">
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.lectureStep.insertExam.insertSingle.choiceMsg2'
                    )
                  }}
                </p>
                <quill-editor
                  class="editor"
                  v-model="answer_description"
                  :rules="answerDescriptionRules"
                  ref="answer_description"
                />
              </v-card>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              elevation="0"
              class="px-9 ma-2 subtitle-2 button-secondary font-weight-light text-capitalize"
              outlined
              :disabled="loading"
              @click="closeDialogQuestion"
              >{{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.insertExam.cancel'
                )
              }}</v-btn
            >
            <v-btn
              elevation="0"
              class="px-10 ma-2 subtitle-2 text-capitalize font-weight-light button-primary"
              @click="validate(null)"
              :disabled="!validationForm() || loading"
              :loading="loading"
              >{{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.insertExam.save'
                )
              }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog v-model="dialogRemoveItem" persistent max-width="450">
      <v-card>
        <v-card-title class="headline">{{
          $vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.insertSingle.confirmDeleteChoice'
          )
        }}</v-card-title>
        <v-card-text>{{
          $vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.insertSingle.confirmDeleteChoiceDetail'
          )
        }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-1"
            dark
            outlined
            @click="dialogRemoveItem = false"
            >{{
              $vuetify.lang.t(
                '$vuetify.courseManagement.lectureStep.insertExam.cancel'
              )
            }}</v-btn
          >
          <v-btn color="error darken-1" dark @click="removeItem">{{
            $vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.insertExam.confirm'
            )
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogSuccess" max-width="450">
      <v-card>
        <v-card-title class="headline">{{
          $vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.insertSingle.saveDone'
          )
        }}</v-card-title>

        <v-card-text>{{
          $vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.insertSingle.saveDoneDetail'
          )
        }}</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" text @click="dialogSuccess = false">{{
            $vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.insertExam.done'
            )
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogSaveFail" persistent max-width="450" color="white">
      <v-card class="pa-3">
        <v-card-title class="mb-3">{{
          $vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.savingFailed'
          )
        }}</v-card-title>
        <v-card-text>
          <p class="subtitle-1">
            {{
              $vuetify.lang.t(
                '$vuetify.courseManagement.lectureStep.insertExam.saveFailMsg'
              )
            }}
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            elevation="0"
            class="mb-0 body-2 text-primary text-capitalize"
            color="white"
            @click="dialogSaveFail = false"
            >{{
              $vuetify.lang.t('$vuetify.courseManagement.lectureStep.confirm')
            }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="warnningToSaveDialog" max-width="500">
      <v-card>
        <v-card-title class="headline">
          {{
            $vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.alertLeavePageTitle'
            )
          }}
        </v-card-title>
        <v-card-text>
          {{
            $vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.alertLeavePageSubTitle'
            )
          }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            elevation="0"
            class="mb-0 body-2 text-capitalize"
            color="white"
            @click="warnningToSaveDialog = false"
          >
            <p class="mb-0">
              {{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.insertYoutube.continue'
                )
              }}
            </p>
          </v-btn>

          <v-btn
            elevation="0"
            class="mb-0 body-2 text-primary text-capitalize"
            color="white"
            @click="confirmCloseDialog()"
          >
            <p class="mb-0">
              {{
                $vuetify.lang.t('$vuetify.courseManagement.lectureStep.exit')
              }}
            </p>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <insert-media-dialog
      :isMediaOpen.sync="mediaDialog"
      :isMediaClose="closeMediaDialog"
      :on-set-video="setVideo"
      :on-set-audio="setAudio"
      :typeMedia.sync="mediaType"
    ></insert-media-dialog>
  </v-row>
</template>

<script>
import 'video.js/dist/video-js.css';
import { videoPlayer } from 'vue-video-player';
import { getListTagLevel } from '@/service/course/exam.js';
import {
  insertChoice,
  updateChoice,
  insertQuestion,
  getQuestionById,
  updateQuestion,
} from '@/service/course/exam';

import insertMediaDialog from '@/views/course/dialog/insertMediaDialog.vue';
import { serverName } from '@/service/configApi';
import { getPrivateVideo } from '@/service/upload/upload.js';

import videojs from 'video.js';
window.videojs = videojs;
import $ from 'jquery';
import { getPrivateFile } from '@/service/upload/upload.js';

// hls plugin for videojs6
require('videojs-contrib-hls/dist/videojs-contrib-hls.js');
export default {
  props: {
    isLectureOpen: {
      type: Boolean,
    },
    isOpen: {
      type: Boolean,
    },
    examId: {
      type: String,
    },
    randomChoices: {
      type: Boolean,
    },
    randomSetting: {
      type: Boolean,
    },
    examFormat: {
      type: String,
    },
    questionId: {
      type: String,
    },
    questionType: {
      type: String,
    },
    articleId: {
      type: String,
    },
    lectureId: {
      type: String,
    },
    lectures: {
      type: Array,
    },
    sectionId: {
      type: String,
    },
    reorderLecture: {
      type: Function,
    },
    closeDialog: {
      type: Function,
    },
  },
  data() {
    return {
      setRandomChoice: false,
      valid: true,
      dialog: false,
      dialog_1: false,
      notifications: false,
      sound: true,
      widgets: false,
      question: '',
      question_score: '',
      answer: [],
      answer_description: '',
      // nameRules: [v => !!v || "กรุณากรอกคะแนน"],
      rows: [1],
      chars: null,
      answer_select: 0,
      answer_correct: null,
      questionRules: [
        (v) =>
          !!v ||
          this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.insertSingle.questionRules'
          ),
      ],
      answerDescriptionRules: [
        (v) =>
          !!v ||
          this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.insertSingle.answerDescriptionRules'
          ),
      ],
      scoreRules: [
        (v) =>
          !!v ||
          this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.insertSingle.scoreRules'
          ),
      ],
      percentRules: [
        (v) => !!v || 'กรุณาระบุเปอร์เซ็นต์ความถูกต้องที่ต้องการ',
        (v) =>
          (v >= 0 && v <= 100) || 'เปอร์เซ็นต์ความถูกต้องมีค่าระหว่าง 0-100',
      ],
      answerRules: [(v) => !!v || 'กรุณากรอกคำตอบ'],

      // audio
      audio_url: '',

      // mediaDialog
      mediaDialog: false,
      audio_id: null,
      video_id: null,

      playerOptions: {
        // videojs options
        fluid: true,
        height: '500',
        muted: true,
        hls: true,
        language: 'en',
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [
          {
            type: 'application/x-mpegURL',
            src:
              'https://cdn.theguardian.tv/webM/2015/07/20/150716YesMen_synd_768k_vp8.webm',
          },
        ],
      },
      successUpload: false,
      isCheckComplete: false,
      urlVideo:
        'http://deknerdteam-09uxa0.cdn.byteark.com/videos/playlist.m3u8',
      cantGetLink: false,
      showUploadPercent: false,
      mediaType: '',
      audioPlaying: false,
      addAnswer: '',
      tempChoiceAnswer: '',
      dialogRemoveItem: false,
      removeItemIndex: null,
      dialogSuccess: false,
      dialogSaveFail: false,

      bools: false,
      arrTagLevel: [],
      selectTagLevel: null,
      scoreTag: null,
      selectTagBool: false,
      arrChoiceId: [],
      itemChoice: [],
      pageLevel: 1,
      pageLevelLength: 1,
      arrAnswer: [],
      loading: false,
      warnningToSaveDialog: false,
    };
  },
  components: {
    insertMediaDialog,
    // VuetifyAudio: () => import("vuetify-audio"),
    VuetifyAudio: () => import('@/components/vuetify-audio'),
    videoPlayer,
  },
  watch: {
    isOpen: async function (newValue) {
      if (newValue) {
        if (this.questionId) {
          // let filterQuestion = this.questions.filter(
          //   question => question._id === this.questionId
          // )[0];
          // console.log(filterQuestion)
          this.arrAnswer = [];
          let result = await getQuestionById({ id: this.questionId });
          await this.getListTagLevel(this.examId);
          this.oldQuestion = result;
          console.log(' this.oldQuestion', this.oldQuestion);
          this.question = result.question;
          this.question_score = result.score;
          // this.answer = result.choices;
          this.answer_description = result.note;
          this.setRandomChoice = result.randomChoice;
          this.audio_id = result.audio;
          this.video_id = result.video;
          result.choices.forEach((choice) => {
            this.answer.push({
              id: choice._id,
              text: choice.text,
              image: choice.image,
              memory_game: choice.memory_game,
              boolean: false,
            });
          });
          this.arrTagLevel.forEach((level, index) => {
            if (result.level == level.id) {
              console.log(result.level + ' ' + level.id + ' ' + level.text);
              this.selectTagLevel = level.id;
              this.scoreTag = level.score;
            }
          });

          this.audio_id ? this.getAudioPreview() : '';
          this.video_id ? this.getPreview('video') : '';
          this.answer_correct = result.correct.map((correct) =>
            result.choices.findIndex((choices) => choices._id === correct._id)
          )[0];
          if (this.examFormat == 'english') {
            this.chars = 'abcdefghijklmnopqrstuvwxyz'.split('');
          } else if (this.examFormat == 'thai') {
            this.chars = 'กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรลวศษสหฬอฮ'.split(
              ''
            );
          } else {
            this.chars = null;
          }

          // this.title = filterLecture.title;
          // this.description = filterLecture.description;
          // let resultLink = await getPrivateFile(filterLecture.file[0]._id);
          // this.fileName = filterLecture.file[0].title;
          // this.urlFile = resultLink;
          // this.oldFileId = filterLecture.file[0]._id;
          // this.otherFile = null
        } else {
          this.valid = true;
          this.dialog_1 = false;
          this.question = '';
          this.addAnswer = '';
          this.question_score = '';
          this.answer_description = '';
          this.setRandomChoice = false;
          this.answer = [];
          this.arrAnswer = [];
          this.itemChoice = [];
          this.selectTagLevel = null;
          this.scoreTag = null;
          this.bools = false;
          this.oldQuestion = {};
          this.answer_select = [];
          this.answer_correct = null;
          this.audio_id = null;
          this.video_id = null;
          if (this.examFormat == 'english') {
            this.chars = 'abcdefghijklmnopqrstuvwxyz'.split('');
          } else if (this.examFormat == 'thai') {
            this.chars = 'กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรลวศษสหฬอฮ'.split(
              ''
            );
          } else {
            this.chars = null;
          }

          // this.$refs.form.reset();
          await this.getListTagLevel(this.examId);
          this.$refs.form.resetValidation();
        }
      } else {
        this.answer = [];
        this.arrAnswer = [];
        try {
          // $(".videoPlayer")[0].player.pause();
          $('video').each(function () {
            $(this).get(0).pause();
          });
        } catch (error) {
          console.log(error);
        }
        try {
          this.audio_url = '';
          this.audioPlaying = false;
          // $('#player')[0].pause();
          // $('#player')[0].currentTime = 0;
        } catch (error) {
          console.log(error);
        }
      }

      if (this.examFormat == 'english') {
        this.chars = 'abcdefghijklmnopqrstuvwxyz'.split('');
      } else if (this.examFormat == 'thai') {
        this.chars = 'กขคงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรลวศษสหฬอฮ'.split('');
      } else {
        this.chars = null;
      }
    },
  },

  mounted() {},
  methods: {
    validationForm() {
      let bool = true;

      // this.answer.forEach((item) => {
      //   if (item.text.length < 1) {
      //     bool = false;
      //   }
      // });
      if (this.bools == true) {
        bool = false;
      }
      if (!this.selectTagLevel && this.typeOfExam == true) {
        bool = false;
      }
      if (this.answer.length == 0 || this.answer_correct == null) {
        bool = false;
      }
      return this.valid && this.question != '' && bool;
    },
    editOptionAnswer(item) {
      console.log('editOptionAnswer -> item', item);
      let index = this.answer.indexOf(item);
      this.tempChoiceAnswer = item.text;
      item.boolean = true;
      this.bools = true;
    },
    canCelEditOptionAnswer(item) {
      // item.text = this.tempChoiceAnswer;
      // this.bools = false;
      let index = this.answer.indexOf(item);
      // if (item.id) {
      item.text = this.tempChoiceAnswer;
      item.boolean = false;
      this.bools = false;
      // } else {
      //   this.removeRow(item);
      //   this.bools = false;
      // }
    },
    confirmOption(item) {
      item.boolean = false;
      this.bools = false;
    },
    removeRow: function (item) {
      console.log(item);
      let index = this.answer.indexOf(item);
      if (this.answer.length > 1) {
        this.answer.splice(index, 1);
      } else {
        this.answer.splice(index, 1);
        this.bools = false;
      }
    },
    addRowAnswer() {
      this.tempChoiceAnswer = '';
      this.answer.push({ text: this.addAnswer, boolean: false });
      this.bools = false;
      this.addAnswer = '';
    },
    openRemoveItemDialog(item) {
      let index = this.answer.indexOf(item);
      this.itemChoice = item;
      this.dialogRemoveItem = true;
      if (this.answer.length > 1) {
        this.removeItemIndex = index;
      }
    },
    async removeItem() {
      if (this.answer.length > 1) {
        if (this.answer_correct === this.removeItemIndex) {
          this.answer_correct = null;
        } else if (this.answer_correct > this.removeItemIndex) {
          this.answer_correct = this.answer_correct - 1;
        }
        this.answer.splice(this.removeItemIndex, 1);
      }
      this.validate(this.itemChoice);
      this.dialogRemoveItem = false;
    },
    async getListTagLevel(examId) {
      let params = {
        idexam: examId,
        sort: 'created_at',
        sortby: 1,
        page: this.pageLevel,
        limit: 100,
      };
      this.arrTagLevel = [];
      let result = await getListTagLevel(params);
      console.log(result);
      if (result.data.length != 0) {
        this.settingLevel = true;
        this.typeOfExam = true;
        result.data.forEach((level) => {
          this.arrTagLevel.push({
            id: level._id,
            text: level.title,
            score: level.score,
            sumScore: level.score * level.choose,
            numberOfQuestion: level.choose,
            countQuestion: level.countQuestion,
            boolean: false,
          });
        });
        console.log(this.arrTagLevel);
      } else {
        this.settingLevel = false;
      }
    },
    changeTag(idTag) {
      this.arrTagLevel.forEach((level) => {
        if (idTag == level.id) {
          this.scoreTag = level.score;
          this.selectTagBool = true;
        }
      });
    },

    async validate(valueOption) {
      let statusCode = false;
      let arrChoiceId = [];
      let choiceCorrect = [];
      this.loading = true;
      if (this.$refs.form.validate()) {
        if (valueOption) {
          if (valueOption.id) {
            let result = await updateChoice({
              id: valueOption.id,
              text: valueOption.text,
            });
            if (result.code && result.code != 200) {
              statusCode = result.code;
              this.dialogSaveFail = true;
            } else {
              statusCode = true;
              this.bools = false;
              valueOption.boolean = false;
            }
          } else {
            let result = await insertChoice({ text: valueOption.text });
            if (result.code && result.code != 200) {
              statusCode = result.code;
              this.dialogSaveFail = true;
            } else {
              statusCode = true;
              this.bools = false;
              valueOption.boolean = false;
              this.answer.pop();
              this.answer.push({
                id: result._id,
                text: result.text,
                image: result.image,
                memory_game: result.memory_game,
                boolean: false,
              });
            }
          }
        } else {
          // no valueoption
          for (var i = 0; i < this.answer.length; i++) {
            if (this.answer[i].id) {
              let result = await updateChoice({
                id: this.answer[i].id,
                text: this.answer[i].text,
              });
              await arrChoiceId.push(result._id);
            } else {
              let result = await insertChoice({
                text: this.answer[i].text,
              });
              await arrChoiceId.push(result._id);
            }
          }
          if (arrChoiceId) {
            arrChoiceId.forEach((value, index) => {
              if (this.answer_correct === index) {
                choiceCorrect.push(value);
              }
            });
          }
          // this.answer.forEach(async (choice) => {
          //   if (choice.id) {
          //     await this.arrChoiceId.push(choice.id);
          //   }
          // });
          // console.log(this.arrChoiceId);

          let tag_score = null;
          let level = this.arrTagLevel.find((x) => x.id == this.selectTagLevel);
          if (level != null) {
            tag_score = level.score || 0;
          }

          let question = {
            idexam: this.examId,
            typeQuestion: 'single',
            question: this.question,
            choices: arrChoiceId,
            correct: choiceCorrect,
            note: this.answer_description,
            randomChoice: this.randomChoices,
            score: this.selectTagLevel ? tag_score : this.question_score,
            video: this.video_id,
            audio: this.audio_id,
            level: this.selectTagLevel,
          };

          if (this.articleId) {
            question = {
              ...question,
              articleQuestion: this.articleId,
            };
          }

          if (this.questionId) {
            let resultQuestion = await updateQuestion({
              id: this.questionId,
              ...this.oldQuestion,
              ...question,
            });
            if (resultQuestion.code && resultQuestion.code != 200) {
              this.dialogSaveFail = true;
            } else {
              this.bools = false;
              this.loading = false;
              this.dialogSuccess = true;
              this.arrChoiceId = [];
              valueOption ? (valueOption.boolean = false) : '';
              this.addAnswer = '';
              let result = await getQuestionById({ id: this.questionId });
              this.answer = [];
              result.choices.forEach((choice) => {
                this.answer.push({
                  id: choice._id,
                  text: choice.text,
                  image: choice.image,
                  memory_game: choice.memory_game,
                  boolean: false,
                });
              });
            }
            if (!valueOption) {
              this.closeDialog();
              this.clearDateValidation();
            }
            this.arrChoiceId = [];
          } else {
            if (!valueOption) {
              let resultQuestion = await insertQuestion(question);
              if (resultQuestion.code && resultQuestion.code != 200) {
                this.dialogSaveFail = true;
              } else {
                this.loading = false;
                this.dialogSuccess = true;
                valueOption ? (valueOption.boolean = false) : '';
                this.addAnswer = '';
                this.bools = false;
                let result = await getQuestionById({ id: resultQuestion._id });
                this.answer = [];
                result.choices.forEach((choice) => {
                  this.answer.push({
                    id: choice._id,
                    text: choice.text,
                    image: choice.image,
                    memory_game: choice.memory_game,
                    boolean: false,
                  });
                });
                console.log(this.answer);
              }
              this.closeDialog();
              this.clearDateValidation();
            }
            valueOption ? (valueOption.boolean = false) : '';
            this.addAnswer = '';
            this.bools = false;
            this.arrChoiceId = [];
          }
          this.arrChoiceId = [];
        } // end
      } else {
        this.dialogSaveFail = true;
      }
    },
    async closeDialogQuestion() {
      let data = {
        question: this.question,
        question_score: this.question_score,
        answer_description: this.answer_description,
        setRandomChoice: this.setRandomChoice,
        audio_id: this.audio_id,
        video_id: this.video_id,
        answer: this.answer,
        arrTagLevel: this.arrTagLevel,
        answer_correct: this.answer_correct,
      };
      console.log('closeDialogQuestion -> data', data);
      if (JSON.stringify(this.oldQuestion) !== JSON.stringify(data)) {
        this.warnningToSaveDialog = true;
      } else {
        this.closeDialog();
        this.clearDateValidation();
      }
    },
    confirmCloseDialog() {
      this.warnningToSaveDialog = false;
      this.closeDialog();
      this.clearDateValidation();
    },
    clearDateValidation() {
      this.valid = true;
      this.dialog_1 = false;
      this.question = '';
      this.addAnswer = '';
      this.question_score = '';
      this.answer_description = '';
      this.setRandomChoice = false;
      this.answer = [];
      this.arrAnswer = [];
      this.itemChoice = [];
      this.selectTagLevel = null;
      this.scoreTag = null;
      this.bools = false;
      this.oldQuestion = {};
      this.answer_select = [];
      this.answer_correct = null;
      this.audio_id = null;
      this.video_id = null;
      this.$refs.form.resetValidation();
    },
    checkMinScore() {
      if (this.question_score < 0) this.question_score = 0;
    },
    async closeMediaDialog() {
      this.mediaDialog = false;
      //this.registerTutoralert = true;
    },
    setVideo(data) {
      this.video_id = data;
      this.getPreview('video');
    },
    setAudio(data) {
      this.audio_id = data;
      this.getAudioPreview();
    },
    async getAudioPreview() {
      this.audio_url = await getPrivateFile(this.audio_id);
      if (this.audio_url) {
        this.isCheckComplete = true;
        this.audioPlaying = true;
      }
    },
    async getPreview(type) {
      let resultLink = await getPrivateVideo(
        type == 'audio' ? this.audio_id : this.video_id
      );
      if (resultLink.isCheckComplete !== undefined) {
        this.isCheckComplete = resultLink.isCheckComplete;
        if (resultLink.isCheckComplete) {
          type == 'audio'
            ? (this.audio_url =
                resultLink.urllocalhost +
                `?token=${localStorage.getItem(
                  'x-session-token'
                )}&server=${serverName}`)
            : this.playerOptions.sources[0].src =
                resultLink.url
          this.audioPlaying = true;
        } else {
          type == 'audio'
            ? (this.audio_url =
                resultLink.urllocalhost +
                `?token=${localStorage.getItem(
                  'x-session-token'
                )}&server=${serverName}`)
            : this.playerOptions.sources[0].src =
                resultLink.urllocalhost 
          this.audioPlaying = true;
        }

        //this.urlVideo = `https://fleet.byteark.com/player?url=${resultLink}`;
        // this.successUpload = true;
        // this.pendingUpload = false;
      }
    },
    deletemedia(type) {
      type == 'audio' ? (this.audio_id = null) : (this.video_id = null);
    },
    openMediaDialog(type) {
      type == 'audio' ? (this.mediaType = 'audio') : (this.mediaType = 'video');
      this.mediaDialog = true;
    },
  },
};
</script>
<style >
.rowContentmange {
  border-style: solid;
  border-radius: 15px;
  border-color: rgb(195, 195, 195);
  border-right-width: thin;
  border-top-width: thin;
  border-left-width: thin;
  border-bottom-width: thin;
}
.lecture-card {
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.19);
  border-radius: 15px;
  transition: transform 0.3s ease-in-out;
}
.single-form .btn-style {
  margin-left: 120px;
  margin-right: 120px;
}
.single-form .btn-add-style {
  margin-left: 45px;
  margin-right: 45px;
}
.single-form .card-style:focus {
  border-color: #1976d2;
  box-shadow: 0 0 3px 0px #1976d2;
  /* background-color: white; */
  background-color: #1976d2;
}
.single-form .card-padding {
  padding: 40px;
}
.single-form .editor_answer .ql-container {
  min-height: 90px;
}
.single-form .editor .ql-container {
  min-height: 150px;
}
.single-form .widthRow {
  width: 98%;
}
@media only screen and (max-width: 1024px) {
  /* .v-card__text.dialogStyle {
    width: 100%;
    margin: 0 auto;
  } */
  .single-form .btn-style {
    margin-left: 60px;
    margin-right: 60px;
  }
  .single-form .btn-add-style {
    margin-left: 22.5px;
    margin-right: 22.5px;
  }
  .single-form .card-padding {
    padding: 20px;
  }
}
</style>
<style scoped>
.text-primary {
  color: rgb(66, 154, 216) !important;
}
.button-secondary {
  color: rgb(65, 65, 65);
  border: 1px solid rgb(195, 195, 195);
}
.button-primary {
  background-color: rgb(66, 154, 216) !important;
  color: white;
}
.upload-btn-wrapper input[type='file'] {
  font-size: 100px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
}
.upload-btn-wrapper input[type='file']:hover {
  cursor: pointer;
}
.upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
  width: 170px !important;
}
.btn-choose {
  color: rgba(0, 0, 0, 0.65);
  background-color: white;
  padding: 8px 20px;
  font-size: 16px;
  width: 170px !important;
  border-radius: 5px;
  border: 1px solid #e0e0e0;
}
</style>
